// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1BtUQ","footer":"ModalUpdate_footer__3e0Mr"};